var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscription-plans-view-container"},[_c('headerbar'),_c('div',{staticClass:"go-back",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"fa fa-chevron-left"})]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }